import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import httpClient from "../../provider/httpClient";

const ProductForm = () => {
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState(null);
  const [categoriesData, setCategoriesData] = useState([]);
  const [unitsData, setUnitsData] = useState([]);
  const [taxTypeData, setTaxTypeData] = useState([{ "id": 0, "name": "--Select--" }, { "id": 1, "name": "Exclusive" }, { "id": 2, "name": "Inclusive" }]);
  const [categorySelected, setCategorySelected] = useState("");
  const [unitSelected, setUnitSelected] = useState("");
  const [taxTypeSelected, setTaxTypeSelected] = useState(0);
  const [price, setPrice] = useState(0.00);
  const [cost, setCost] = useState(0.00);

  const navigate = useNavigate();

  const formID = searchParams.get("form_id");
  useEffect(() => {
    fetchCategories();
    fetchUnits();
    if (formID > 0) {
      fetchData(formID);
    }
  }, [formID]);

  const fetchData = async (formID) => {
    try {
      const response = await httpClient.get(
        `/product/${formID}`
      );
      setFormData(response.data.data);
      setPrice(response.data.data.product_price);
      setCategorySelected(response.data.data.category.id);
      setUnitSelected(response.data.data.product_unit);
      setCost(response.data.data.product_cost);
      setTaxTypeSelected(response.data.data.product_tax_type);
      // console.log(categorySelected, unitSelected, response.data.data.is_active);
    } catch (error) {
      console.error(error);
    }
  }

  const fetchCategories = async () => {
    try {
      const response = await httpClient.post(`/product-category/all?limit=100`);
      const data = response.data.data.data;
      console.log(data);
      setCategoriesData(data);
      if (formID < 1) {
        setCategorySelected(data[0].id);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const fetchUnits = async () => {
    try {
      const response = await httpClient.get(`/unit/all`);
      const data = response.data.data;
      // console.log(data);
      setUnitsData(data);
      if (formID < 1) {
        setUnitSelected(data[0].short_name);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let userFormData = {
      product_name: e.target.inputName.value,
      product_code: e.target.inputCode.value,
      product_unit: e.target.inputUnit.value,
      product_quantity: e.target.inputQuantity.value,
      product_cost: e.target.inputCost.value,
      product_price: e.target.inputPrice.value,
      product_stock_alert: e.target.inputAQuantity.value,
      product_order_tax: e.target.inputTax.value,
      product_tax_type: e.target.tax_type.value,
      product_note: e.target.inputNotes.value,
      category_id: e.target.category.value
    }
    if (formData) {
      update(userFormData);
    } else {
      add(userFormData);
      setFormData(null);
    }
  };

  // Create a new user
  const add = async (userData) => {
    try {
      const response = await httpClient.post('/product', userData);
      const data = await response.data;
      // console.log(data);
      toast(data.message);
      if (data.status) {
        navigate('/dashboard/products');
      }
    } catch (error) {
      console.error('Error adding user:', error);
    }
  };

  // Update an existing user
  const update = async (userData) => {
    try {
      const response = await httpClient.put(`/product/${formData.id}`, userData);
      const data = await response.data;
      // console.log(data);
      if (data.status) {
        toast("Product updated");
      }
      setFormData(data.data);
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  return (
    <>
      <Link to='/dashboard/products' className="btn btn-primary" >Back</Link>
      <hr />
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">Product Form</h6>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="inputName">Name</label>
                <input type="text" className="form-control" defaultValue={formData ? formData.product_name : ''} name="inputName" placeholder="Name" required />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="inputCode">Code</label>
                <input type="text" className="form-control" defaultValue={formData ? formData.product_code : ''} name="inputCode" placeholder="Code" required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="category">Category <span className="text-danger">*</span></label>
                <select className="form-control" value={categorySelected} onChange={e => setCategorySelected(e.target.value)} name="category" required>
                  {
                    categoriesData.map((e, key) => {
                      return <option key={e.category_name} value={e.id}>{e.category_name}</option>;
                    })
                  }
                </select>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="inputUnit">Unit</label>
                <select className="form-control" value={unitSelected} onChange={e => setUnitSelected(e.target.value)} name="inputUnit" required>
                  {
                    unitsData.map((e, key) => {
                      return <option key={e.name} value={e.short_name}>{e.name}</option>;
                    })
                  }
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="inputCost">Cost</label>
                <input type="number" className="form-control" value={cost} name="inputCost" min={0} onChange={e => setCost(e.target.value)} required />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="inputPrice">Price</label>
                <input type="number" className="form-control" value={price} name="inputPrice" min={0} onChange={e => setPrice(e.target.value)} required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="inputQuantity">Quantity</label>
                <input type="number" className="form-control" defaultValue={formData ? formData.product_quantity : ''} name="inputQuantity" min={1} required />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="inputAQuantity">Alert Quantity</label>
                <input type="number" className="form-control" defaultValue={formData ? formData.product_stock_alert : ''} name="inputAQuantity" min={1} required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="tax_type">Tax Type</label>
                <select className="form-control" value={taxTypeSelected} onChange={e => setTaxTypeSelected(e.target.value)} name="tax_type" >
                  {
                    taxTypeData.map((e, key) => {
                      return <option key={e.name} value={e.id}>{e.name}</option>;
                    })
                  }
                </select>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="inputTax">Tax (%)</label>
                <input type="text" className="form-control" defaultValue={formData ? formData.product_order_tax : ''} name="inputTax" placeholder="Tax" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-12">
                <label htmlFor="inputNotes">Notes</label>
                <textarea type="text" className="form-control" defaultValue={formData ? formData.product_note : ''} name="inputNotes"></textarea>
              </div>
            </div>
            <button type="submit" className="btn btn-primary">{formData ? ('Update') : ('Submit')}</button>
          </form>
        </div>
      </div>
    </>
  )
}

export default ProductForm;